import { inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  authState,
  authSelectors,
  UserGroupStoreFacade,
  authActions,
} from '@sleipai/sleip-ngrx-store';
import { filter, take, timeout, forkJoin, map, tap } from 'rxjs';
import { isEmpty } from 'lodash';

export const authenticatedDataLoaderCheckGuard: CanActivateFn = () => {
  const destroyRef = inject(DestroyRef);
  const authStore = inject(Store<authState.State>);
  const groupFacade = inject(UserGroupStoreFacade);

  authStore.dispatch(authActions.loadUserData());

  const isAuthStorLoaded = authStore.select(authSelectors.selectIsLoaded).pipe(
    takeUntilDestroyed(destroyRef),
    filter((loaded) => loaded === true),
    take(1), // Take first true value
    timeout(15000), // Timeout after 15 seconds
  );

  const authUser = authStore.select(authSelectors.selectUser).pipe(
    takeUntilDestroyed(destroyRef),
    filter((user) => !isEmpty(user)),
    take(1), // Take first true value
    tap((user) => {
      if (user.group?.id)
        groupFacade.fetchCurrentUserGroupEntity$(user.group?.id);
    }),
    timeout(15000), // Timeout after 15 seconds
  );

  return forkJoin({ isAuthStorLoaded, authUser }).pipe(
    map(({ isAuthStorLoaded, authUser }) => {
      return isAuthStorLoaded && !isEmpty(authUser);
    }),
  );
};
